import { a as o, j as t } from "../../../../../emotion-react-jsx-runtime.browser.esm-CsRinUqv.js";
import "@ionic/react";
import "../../../../../FeatureFlagProvider-BgPZZ37K.js";
import "react";
import "../../../../../react-paginate-Lh5zQzpz.js";
import { ButtonEdit as r } from "../ButtonEdit/ButtonEdit.js";
import "../../../LoadingInterstitial/LoadingInterstitial.js";
import "../../../../contexts/DesignSystemProvider/DesignSystemProvider.js";
import '../../../../../css/Section.css';const c = "_section_dl9gf_1", l = {
  section: c
};
function x(e) {
  const {
    children: s,
    title: i,
    onEditClick: n
  } = e;
  return /* @__PURE__ */ o("div", {
    className: l.section,
    children: [/* @__PURE__ */ o("div", {
      style: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 24
      },
      children: [i && /* @__PURE__ */ t("h2", {
        style: {
          margin: 0,
          fontSize: "var(--swing-font-xl) !important",
          fontWeight: "var(--swing-font-semibold)"
        },
        children: i
      }), n && // avoid button 100% width default
      /* @__PURE__ */ t("div", {
        children: /* @__PURE__ */ t(r, {
          onClick: () => n()
        })
      })]
    }), s]
  });
}
export {
  x as Section
};
